// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3RmSlilcS8b2HcNVnmERey"};